import React, { useState } from "react";
import CopyrightLogo from "../../assets/img/copyright-256x256.jpg";
import BugsLogo from "../../assets/img/bug-report-256x256.png";
import FeedbackLogo from "../../assets/img/smartai-studio-feedback.jpg";
import platform from "../../assets/img/logo2_tiny.png";

import {
  Button,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  CardActions,
  Avatar,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "./About.css";
import { EmailIcon } from "react-share";

export default function About() {
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [expanded, setExpanded] = useState(false);
  const emailBug = (
    <div>
      <Typography className="pt-4" variant="body2" component="div">
        Email Us{" "}
        <a href="mailto:support@smartai.studio">support@smartai.studio</a>
      </Typography>
    </div>
  );
  const emailCopyright = (
    <div>
      <Typography className="pt-4" variant="body2" component="div">
        Email Us{" "}
        <a href="mailto:copyright@smartai.studio">copyright@smartai.studio</a>
      </Typography>
    </div>
  );
  const emailFeedback = (
    <div>
      <Typography className="pt-4" variant="body2" component="div">
        Email Us{" "}
        <a href="mailto:feedback@smartai.studio">feedback@smartai.studio</a>
      </Typography>
    </div>
  );
  const emailSaSSY = (
    <div>
      <Typography className="pt-4" variant="body2" component="div">
        Email Us <a href="mailto:info@smartai.systems">info@smartai.systems</a>
      </Typography>
    </div>
  );

  const isMobile = useMediaQuery("(max-width:600px)");

  const MembershipBox = !isMobile ? (
    <Card
      sx={{
        width: 320,
        bgcolor: "background.default",
        color: "text.primary",
        padding: 1,
        margin: 2,
      }}
    >
      <CardHeader
        avatar={
          <Box>
            <Avatar sx={{ backgroundColor: "black" }}>M</Avatar>
            <p />
            <Avatar>
              <EmailIcon />
            </Avatar>
          </Box>
        }
        title={
          <Typography variant="h6" component="h2">
            Membership Inquiry?
          </Typography>
        }
        subheader={emailBug}
      />
      <CardContent>
        <CardMedia
          component="img"
          height="128"
          width="128"
          image={FeedbackLogo}
        />
        <Typography sx={{ align: "left" }} variant="body2" component="div">
          <ul className="left">
            <li
              style={{
                textAlign: "left",
                marginTop: "10px",
              }}
            >Modify / Cancel Membership?</li>
          </ul>
          Please include your login email
        </Typography>
      </CardContent>
    </Card>
  ) : (
    <></>
  );

  const CopyrightBox = !isMobile ? (
    <Card
      sx={{
        width: 320,
        bgcolor: "background.default",
        color: "text.primary",
        padding: 1,
        margin: 2,
      }}
    >
      <CardHeader
        avatar={
          <Box>
            <Avatar sx={{ backgroundColor: "black" }}>C</Avatar>
            <p />
            <Avatar>
              <EmailIcon />
            </Avatar>
          </Box>
        }
        title={
          <Typography variant="h6" component="h2">
            Copyright Inquiry?
          </Typography>
        }
        subheader={emailCopyright}
      />
      <CardContent>
        <CardMedia
          component="img"
          height="128"
          width="128"
          image={CopyrightLogo}
        />
        <Typography sx={{ align: "left" }} variant="body2" component="div">
          Please include:
          <ul className="left">
            <li>claim - which image (url or id)</li>
            <li>proof - copyrighted image (url)</li>
          </ul>
        </Typography>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
  const BugsBox = (
    <Card
      sx={{
        width: 320,
        bgcolor: "background.default",
        padding: 1,
        margin: 2,
      }}
    >
      <CardHeader
        avatar={
          <Box>
            <Avatar sx={{ backgroundColor: "#d74a4a" }}>B</Avatar>
            <p />
            <Avatar>
              <EmailIcon />
            </Avatar>
          </Box>
        }
        title={
          <Typography variant="h6" component="h2">
            Report Bug?
          </Typography>
        }
        subheader={emailBug}
      />
      <CardContent>
        <CardMedia
          component="img"
          height="128"
          width="128"
          image={BugsLogo}
          sx={{
            align: "center",
          }}
        />
        <Typography
          sx={{
            align: "left",
          }}
          variant="body2"
          component="div"
        >
          <ul className="left">
            <li>issue - what happened?</li>
            <li>browser - which browser?</li>
            <li>device - which device?</li>
          </ul>
        </Typography>
      </CardContent>
    </Card>
  );
  const FeedbackBox = (
    <Card
      sx={{
        width: 320,
        bgcolor: "background.default",
        color: "text.primary",
        padding: 1,
        margin: 2,
      }}
    >
      <CardHeader
        avatar={
          <Box>
            <Avatar sx={{ backgroundColor: "#183e4b" }}>F</Avatar>
            <p />
            <Avatar>
              <EmailIcon />
            </Avatar>
          </Box>
        }
        title={
          <Typography variant="h6" component="h2">
            Feedback Inquiry?
          </Typography>
        }
        subheader={emailFeedback}
      />
      <CardContent>
        <CardMedia
          component="img"
          height="128"
          width="128"
          image={FeedbackLogo}
        />
        <Typography sx={{ align: "left" }} variant="body2" component="div">
          <ul className="left">
            <li>what do you like?</li>
            <li>what do you hate?</li>
            <li>what do you want?</li>
          </ul>
        </Typography>
      </CardContent>
    </Card>
  );

  const SaSSYBox = !isMobile ? (
    <Card
      sx={{
        maxWidth: 320,
        bgcolor: "background.default",
        color: "text.primary",
        padding: 1,
        margin: 2,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "0px solid black",
        }}
      >
        <CardHeader
          avatar={
            <Box>
              <Avatar sx={{ backgroundColor: "#8BA0A4" }}>S</Avatar>
              <p />
              <Avatar>
                <EmailIcon />
              </Avatar>
            </Box>
          }
          title={
            <Typography variant="h6" component="h2">
              SaSSY Inquiry?
            </Typography>
          }
          subheader={emailSaSSY}
        />
        <CardMedia component="img" height="140" width="140" image={platform} />
        <Typography sx={{ align: "left" }} variant="body2" component="div">
          Considering using SaSSY to drive your Generative AI projects?
        </Typography>
        <Typography sx={{ align: "left" }} variant="body2" component="div">
          Send us an inquiry!
        </Typography>
      </CardContent>
    </Card>
  ) : (
    <></>
  );

  const faqAccordion = (
    <div
      className="row"
      sx={{
        position: "sticky",
      }}
    >
      <div className="bg-banner-info px-4 text-center ">
        <div className="d-flex align-items-center justify-content-center col-lg-6 mx-auto py-2">
          <p className="mb-0 me-3">Frequently Asked Questions (FAQ)</p>
        </div>
      </div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            fontWeight: "bold",
            fontSize: "1.0em",
            color: "text.primary",
            backgroundColor: "background.paper",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              width: "33%",
              flexShrink: 0,
              fontWeight: "bold",
              fontSize: "1.0em",
              color: "text.primary",
              backgroundColor: "background.paper",
            }}
          >
            Subscriptions & Credits
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Monthly Credits, Wallet Credits & Credit Packs
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            textAlign: "left",
          }}
        >
          <Typography>
            When you first sign up with your name and email, you will be
            provided a Free Subscription. We do not ask for your credit card
            information during signup.
          </Typography>
          <br />

          <Typography>
            Free Subscription operates on a monthly cadence. The subscription
            will provision you a set number of renewable credits each month.
            These credits will be renewed every first of the month and do not
            roll over.
          </Typography>
          <br />
          <Typography>
            In addition you also have a 'Wallet' with credits that do not
            expire. Wallet credits are purchased seperately by buying a 'credit
            pack' and are not tied to the monthly subscription schedule. These
            are one time purchases through our payment providers and we do not
            store your credit card information.
          </Typography>

          <br />
          <Typography>
            Wallet credits will be used if/when your monthly credits reach zero
            or cannot fully cover a transaction, this will ensure you spend your
            free credits first, before using your purchased credits.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            fontWeight: "bold",
            fontSize: "1.0em",
            color: "text.primary",
            backgroundColor: "background.paper",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              width: "33%",
              flexShrink: 0,
              fontWeight: "bold",
              fontSize: "1.0em",
              color: "text.primary",
              backgroundColor: "background.paper",
            }}
          >
            Generative AI
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Curated and User Generated AI Images, AI Agent Generated Content
          </Typography>
        </AccordionSummary>        
        <AccordionDetails
          sx={{
            textAlign: "left",
          }}
        >
          <Typography>
Q: What is GenAI, and how does it create content? <br />
A: Generative AI (GenAI) models use advanced machine learning models to generate text, images, and other creative outputs based on user prompts. 
<br />The outputs are synthesized enabling tools to create stories, scripts, or variations of stock images.<br />
<br />
Q: Are there risks when using GenAI-generated content?<br />
A: Yes. Some common risks include:<br />
<ul>
  <li>Inaccurate Information: AI might generate factually incorrect or misleading content.</li>
  <li>Plagiarism or Copyright Issues: Although AI generates content, it could inadvertently replicate copyrighted works.</li>
  <li>Bias and Offensive Content: AI outputs might reflect biases or include inappropriate material present in the training data.</li>
  <li>Misuse of Generated Material: Users should consider ethical and legal guidelines for using AI-generated content, especially in professional or public domains.</li>
</ul>
          </Typography>
          
          <Typography
            sx={{
              padding: "1rem",
            }}
          >
            <strong>Generated Images</strong>          
          </Typography>
          <Typography>
            <ul>
              <li>
                Pregenerated Curated Images - original images generated
                exclusively by the SmartAI Generative Platform (SSGP), prompted
                by the SSGP Prompt Engine and curated by SmartAI algorithms and
                personnel (currently available in ALPHA release).
              </li>
              <li>
                User Generated AI Images - original images generated on-demand
                by you, when utilizing our BETA 'Studio' features. On demand AI
                images are guided by the user's input and sent to the SmartAI
                Generative Platform (SSGP) for prompt curation and generation.
              </li>
              <li>
                Artist Images - original images uploaded to our platform by
                registered SmartAI partner artists (available in FULL release)
              </li>
            </ul>
          </Typography>

          <Typography
            sx={{
              paddingTop: "1rem",
            }}
          >
            <strong>Stories, Poems, and Scripts</strong>          
            </Typography>
            <Typography
            sx={{
              padding: "1rem",
            }}
            >
            <br />Q: Can I use AI-generated stories or scripts for commercial projects?
          <br />A: Yes, smartai.studio grants royalty free usage of generated content with a few exceptions, please review our <a target="_blank" href="https://app.termly.io/policy-viewer/policy.html?policyUUID=376fff7a-0bd7-4e6b-a466-732926a0cbce">
              terms of use
            </a>. 
          <br /><br /><strong>NOTE: </strong>Licensing does not guarantee immunity from intellectual property disputes if the content is deemed too similar to existing works.
          <br />
          <br />Q: How do I ensure ethical use of AI-generated creative content?
          <br />A: Be transparent about the use of AI tools. Avoid claiming AI-generated material as entirely original, and validate the accuracy of any factual content before sharing or publishing.
          <br />
          <br />Q: Can I use AI-generated content for educational purposes?
          <br />A: Yes, AI-generated content can be used for educational purposes, but always verify the accuracy of the information before sharing it with students or colleagues.
          </Typography>
          <Typography
            sx={{
              padding: "1rem",
            }}
          >
            <strong>Recipes and Practical Instructions</strong>          
          
            <br />Q: Can I rely on AI-generated recipes or instructions?
          <br />A: AI-generated recipes might be incomplete or contain unsafe combinations. Always cross-check AI-generated instructions with expert sources before use.
          <br />
          <br />Q: What should I watch out for when using AI to create recipes?
          <br />A: Verify measurements, ingredient interactions, and preparation steps to avoid potentially harmful outcomes.
          </Typography>
          <br />
          <Typography>
            To find out more about the SmartAI SSGP Platform, please visit{" "}
            <a target="_blank" href="https://smartai.systems/platform">
              smartai.systems - platform
            </a>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            fontWeight: "bold",
            fontSize: "1.0em",
            color: "text.primary",
            backgroundColor: "background.paper",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              width: "33%",
              flexShrink: 0,
              fontWeight: "bold",
              fontSize: "1.0em",
              color: "text.primary",
              backgroundColor: "background.paper",
            }}
          >
            Copyright & Usage
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Copyright, Usage, Are These Images Real?
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            textAlign: "left",
          }}
        >
           <Typography>
            <strong>smartai.studio</strong> images are generated via AI models
            and algorithms. These models have demonstrated incredible accuracy
            in generating images that are indistinguishable from real images.
            However, we do not claim that these images are real or accurate in
            any real world, scientific or medical context.
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            SmartAI recommends you use these images in your digital projects,
            social media and/or digital communications to provide visual context
            and help you communicate your ideas. SmartAI does not recommend you
            use these images as content where scientific, medical and real world
            truths are implied or explicitly stated.
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            <strong>Royalty-Free Usage</strong>: All images downloaded from{" "}
            <strong>smartai.studio</strong> using the proper download features of smartai.studio, are royalty-free, 
            meaning you can use them in your projects without paying additional fees or royalties for each use. 
            You are free to use these images across a wide range of projects including: 
            <br />
            <br />◆ Websites <br />◆ Social Media Posts <br />◆ Digital Marketing
            Campaigns <br />◆ Presentations <br />◆ Print Media <br />◆ Videos
            </Typography>
            <br /><Divider /><br />
            <Typography>
            <strong>Usage Limitations</strong>: While
            our images are versatile and free to use in many contexts, there are
            a few limitations to keep in mind: <br /><br />◆ Reselling Prohibited: You may not
            resell, redistribute, or sublicense the images in any manner that
            competes with smartai.studio, such as creating a similar image
            portal for resale. <br />◆ Prohibited Uses: Do not use the images in any
            context that implies or explicitly states scientific, medical, or
            real-world truths without proper verification from credible sources.
            <br />◆ Compliance: Always ensure your use of images complies with local
            laws and regulations, especially in contexts that might require
            specific rights or permissions.<br /><br />
          </Typography>
          <Divider />
          <Typography>
          <br /><strong>Copyright</strong>:  In very rare cases, images produced by Generative AI models may
            result in an image that closely resembles a copyrighted image. In
            these cases, SmartAI will remove the image from the platform when
            identified or a successful claim is made via{" "}
            <a href="mailto:copyright@smartai.studio">
              copyright@smartai.studio
            </a>{" "}
            and will not charge you for the image. SmartAI will also notify you
            of the removal and will provide you with a credit to your account to
            compensate you for the removal of the image.
          </Typography>

          <br />
          <Typography>
            Please view our{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://app.termly.io/document/terms-of-use-for-website/376fff7a-0bd7-4e6b-a466-732926a0cbce"
            >
              Terms of Service
            </a>{" "}
            for more information on usage and copyright.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
      <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            fontWeight: "bold",
            fontSize: "1.0em",
            color: "text.primary",
            backgroundColor: "background.paper",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              width: "33%",
              flexShrink: 0,
              fontWeight: "bold",
              fontSize: "1.0em",
              color: "text.primary",
              backgroundColor: "background.paper",
            }}
          >
            Open Source & Licenses
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
          Open Source, Copyright Notices & Licenses
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            textAlign: "left",
          }}
        >
           <Typography>
            <strong>smartai.studio</strong> uses the following open source packages.
            <br />
            <br />◆ react-image-filter -{" "} <a href="https://github.com/Stanko/react-image-filter">https://github.com/Stanko/react-image-filter</a>  MIT License Copyright (c) Stanko Tadić
            <br />◆ react-fontawesome -{" "} <a href="http://fontawesome.io">: Font Awesome by Dave Gandy - http://fontawesome.io.</a> License: SIL OFL 1.1
            <br />◆ react-share -{" "} <a href="https://github.com/nygardk/react-share:"> Copyright (c) 2015 Klaus Nygård,</a> MIT License (MIT)
          </Typography>
          <br />
        </AccordionDetails>
      </Accordion>
    </div>
  );

  const renderAboutHeader = (
    <div
      sx={{
        width: "80%",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          backgroundColor: "#f8f9fa",
          padding: "1rem",
          color: "text.primary",
          opacity: "0.8",
        }}     
      > 
      <Typography
        variant="h3"
        color="secondary"
        sx={{
          fontFamily: "Raleway",
          textAlign: "center",
          paddingBottom: "1rem",
          paddingTop: "1rem",
        }}
      >
        <b>About SmartAI Stock Images</b>
      </Typography>

      <Typography
        className="lead mb-2"
        sx={{
          fontFamily: "Raleway",
          textAlign: "center",
        }}
      >
        SmartAI Stock Images is a <span className="bold">smartai.studio</span>{" "}
        production, a solution for creating, downloading and sharing AI
        generated stock images.
      </Typography>
      <Typography
        className="lead mb-2"
        sx={{
          fontFamily: "Raleway",
          textAlign: "center",
        }}
      >
        <span className="bold">smartai.studio</span> is powered by the SmartAI
        Generative AI Platform (SSGP) and is a product of{" "} <a href="https://smartai.systems" target="_blank">SmartAI Systems</a>.
      </Typography>
      <Divider
        sx={{
          bgcolor: "#8BA0A4",
          margin: "1rem",
        }}
      />
      </Box>
    </div>
  );

  return (
    <div
      className="bg-about-hero"
      sx={{
        maxWidth: "100%",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        borderRadius: "0",
        border: "none",
        boxShadow: "none",
        marginBottom: "10px",
      }}
    >
      {renderAboutHeader}
      {faqAccordion}
      <div
        className="row"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          bgcolor: "background.default",
          width: "90%",
        }}
      >
        {FeedbackBox}
        {BugsBox}
        {CopyrightBox}
        {MembershipBox}
      </div>
    </div>
  );
}
